import React, { useState } from 'react';
import TextField from '@mui/material/TextField';

import {
  Card,
  Typography,
  Grid,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  InputAdornment,
  FormHelperText,
  Input,
} from '@mui/material';
import { Field, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { SaveCompanyResponse } from '../../services/Service';
import Page from '../../components/Page';

const Companies = () => {
  const [image, setImage] = useState();

  const CompaniesFormSchema = Yup.object().shape({
    name: Yup.string().required('Please enter name'),
    website: Yup.string().required('Please enter website'),
    price: Yup.number().required('Please enter price'),
    description: Yup.string().required('Please enter description'),
    companyType: Yup.string().required('Please Select company type'),
    // popular: Yup.boolean().required('Please select any one. '),
  });

  const initialValues = {
    name: '',
    website: '',
    price: '',
    description: '',
    logo: 'logo',
    companyType: '',
    popular: false,
  };

  const CompaniesForm = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: CompaniesFormSchema,
    onSubmit: (values, { resetForm }) => {
      SaveCompanyResponse(values, image).then(() => {
        resetForm(initialValues);
      });
    },
  });

  return (
    <>
      <Page title="Companies - SafalSubscriptions">
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Card sx={{ p: 3, width: '930px' }}>
            <Box mb={5}>
              <Typography variant="h4" sx={{ fontSize: '40px', fontWeight: 700, color: '#19C25F' }}>
                Companies
              </Typography>
              <Typography variant="h4" gutterBottom sx={{ fontSize: '15px', fontWeight: 400 }}>
                Enter your details below.
              </Typography>
            </Box>

            <Grid container spacing={1}>
              <FormikProvider value={CompaniesForm}>
                <form onSubmit={CompaniesForm.handleSubmit}>
                  <Grid item xs={12} sm={4}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Input
                        type="file"
                        name="image"
                        variant="standard"
                        size="small"
                        inputProps={{ accept: 'image/*' }}
                        onChange={(event) => {
                          setImage(event.target.files[0]);
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={8}>
                    <FormControl
                      fullWidth
                      sx={{ mb: 3 }}
                      error={CompaniesForm.touched.name && Boolean(CompaniesForm.errors.name)}
                    >
                      <Field
                        as={TextField}
                        id="input1"
                        name="name"
                        label="Name"
                        variant="standard"
                        size="small"
                        value={CompaniesForm.values.name}
                        onChange={CompaniesForm.handleChange}
                        error={CompaniesForm.touched.name && Boolean(CompaniesForm.errors.name)}
                        helperText={CompaniesForm.touched.name && CompaniesForm.errors.name}
                      />
                    </FormControl>
                    <FormControl
                      fullWidth
                      sx={{ mb: 3 }}
                      error={CompaniesForm.touched.companyType && Boolean(CompaniesForm.errors.companyType)}
                    >
                      <Field
                        as={TextField}
                        id="input1"
                        name="companyType"
                        label="Company Type"
                        variant="standard"
                        size="small"
                        value={CompaniesForm.values.companyType}
                        onChange={CompaniesForm.handleChange}
                        error={CompaniesForm.touched.companyType && Boolean(CompaniesForm.errors.companyType)}
                        helperText={CompaniesForm.touched.companyType && CompaniesForm.errors.companyType}
                      />
                    </FormControl>
                    <FormControl
                      fullWidth
                      sx={{ mb: 3 }}
                      error={CompaniesForm.touched.website && Boolean(CompaniesForm.errors.website)}
                    >
                      <Field
                        as={TextField}
                        id="input1"
                        name="website"
                        label="Website"
                        variant="standard"
                        size="small"
                        value={CompaniesForm.values.website}
                        onChange={CompaniesForm.handleChange}
                        error={CompaniesForm.touched.website && Boolean(CompaniesForm.errors.website)}
                        helperText={CompaniesForm.touched.website && CompaniesForm.errors.website}
                      />
                    </FormControl>

                    <FormControl
                      fullWidth
                      sx={{ mb: 3 }}
                      error={CompaniesForm.touched.description && Boolean(CompaniesForm.errors.description)}
                    >
                      <Field
                        as={TextField}
                        id="input1"
                        name="description"
                        multiline
                        rows={3}
                        label="Description"
                        variant="standard"
                        size="small"
                        value={CompaniesForm.values.description}
                        onChange={CompaniesForm.handleChange}
                        error={CompaniesForm.touched.description && Boolean(CompaniesForm.errors.description)}
                        helperText={CompaniesForm.touched.description && CompaniesForm.errors.description}
                      />
                    </FormControl>

                    <FormControl
                      fullWidth
                      sx={{ mb: 3 }}
                      error={CompaniesForm.touched.price && Boolean(CompaniesForm.errors.price)}
                    >
                      <InputLabel htmlFor="price">price</InputLabel>
                      <Field
                        as={Input}
                        label="price"
                        name="price"
                        type="number"
                        variant="standard"
                        size="small"
                        value={CompaniesForm.values.price}
                        onChange={CompaniesForm.handleChange}
                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                      />
                      {CompaniesForm.touched.price && CompaniesForm.errors.price ? (
                        <FormHelperText>{CompaniesForm.touched.price && CompaniesForm.errors.price}</FormHelperText>
                      ) : null}
                    </FormControl>

                    <FormControl
                      fullWidth
                      sx={{ mb: 3 }}
                      error={CompaniesForm.touched.popular && Boolean(CompaniesForm.errors.popular)}
                    >
                      <InputLabel id="select4">Popular </InputLabel>
                      <Field
                        as={Select}
                        labelId="select4"
                        id="select4"
                        name="popular"
                        label="Popular"
                        variant="standard"
                        size="small"
                        value={CompaniesForm.values.popular}
                        onChange={CompaniesForm.handleChange}
                      >
                        <MenuItem value="true">Yes</MenuItem>
                        <MenuItem value="false">No</MenuItem>
                      </Field>
                      {CompaniesForm.touched.popular && CompaniesForm.errors.popular ? (
                        <FormHelperText>{CompaniesForm.touched.popular && CompaniesForm.errors.popular}</FormHelperText>
                      ) : null}
                    </FormControl>

                    <Button
                      variant="contained"
                      type="submit"
                      disabled={!(CompaniesForm.isValid && CompaniesForm.dirty)}
                      sx={{
                        width: '170px',
                        height: '45px',
                        bgcolor: '#19C25F',
                        borderRadius: '30px',
                        textTransform: 'none',
                        mt: '25px',
                        boxShadow: '0px 4px 25px rgba(150, 150, 150, 0.15)',
                      }}
                    >
                      Create
                    </Button>
                  </Grid>
                </form>
              </FormikProvider>
            </Grid>
          </Card>
        </Box>
      </Page>
    </>
  );
};

export default Companies;
